<nb-checkbox [checked]="value" [disabled]="disabled" [formControlName]="controlName">
  <ng-content></ng-content>
</nb-checkbox>
